import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpeed = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.999 14.0009L15.199 10.801",
		stroke: "currentColor",
		strokeWidth: 1.42857,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.07198 18C4.36977 16.784 4.00006 15.4044 4 14.0001C3.99995 12.5958 4.36955 11.2162 5.07167 10.0001C5.77378 8.78389 6.78367 7.77397 7.9998 7.07181C9.21594 6.36965 10.5955 6 11.9998 6C13.4041 6 14.7836 6.36965 15.9998 7.07181C17.2159 7.77397 18.2257 8.78389 18.9278 10.0001C19.6299 11.2162 19.9997 12.5958 19.9995 14.0001C19.9995 15.4044 19.6298 16.784 18.9276 18",
		stroke: "currentColor",
		strokeWidth: 1.42857,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgSpeed;
